export default __webpack_public_path__ + "static/media/Ballroll_00112.59c429fb.png";